// ========================================
// Promotion Management - Refactored Types
// Aligned with pos_promohed + pos_promodet schema
// ========================================

export interface OfferCriteriaRow {
    id?: number;
    line_seq: number;
    criteria_type: 'item_group' | 'item' | 'amount_range' | 'payment_mode' | 'location' | 'customer_group';
    criteria_value: string; // comma-separated codes
    amount_min?: number | null;
    amount_max?: number | null;
}

export interface PromotionTypeOption {
    id: number;
    type_code: string;
    type_name: string;
    type_desc?: string;
    criteria_pattern?: string[];
    type_priority: number;
}

export interface PromotionFormData {
    // Header
    promo_code: string;
    promo_name: string;
    promo_desc: string;
    promo_type_id: number | null;

    // Validity
    promo_datefrom: string;
    promo_dateto: string;
    promo_timefrom: string;
    promo_timeto: string;
    promo_days_mask: number; // bitmask 0=Sun...6=Sat
    promo_active: boolean;

    // Offer criteria (dynamic rows)
    offer_criteria: OfferCriteriaRow[];

    // Promotion-level discount fields (global)
    promo_disper: string;
    promo_disamt: string;
    promo_free_item: string;
    promo_free_voucher: string;
}

export interface PromotionToEdit extends PromotionFormData {
    promotion_id?: number;
}

// Day-of-week mapping
export const DAYS_OF_WEEK = [
    { value: 0, label: 'Sun' },
    { value: 1, label: 'Mon' },
    { value: 2, label: 'Tue' },
    { value: 3, label: 'Wed' },
    { value: 4, label: 'Thu' },
    { value: 5, label: 'Fri' },
    { value: 6, label: 'Sat' },
];

// Offer criteria type options
export const CRITERIA_TYPE_OPTIONS: { value: OfferCriteriaRow['criteria_type']; label: string }[] = [
    { value: 'item_group', label: 'Group Selection' },
    { value: 'item', label: 'Item Selection' },
    { value: 'amount_range', label: 'Amount Range' },
    { value: 'payment_mode', label: 'Payment Mode' },
    { value: 'location', label: 'Active Location' },
    { value: 'customer_group', label: 'Customer Group' },
];

/** Convert day bitmask to array of selected day indices */
export function maskToDays(mask: number): number[] {
    const days: number[] = [];
    for (let i = 0; i < 7; i++) {
        if (mask & (1 << i)) {
            days.push(i);
        }
    }
    return days;
}

/** Convert array of selected day indices to bitmask */
export function daysToMask(days: number[]): number {
    return days.reduce((mask, d) => mask | (1 << d), 0);
}